import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { showIntlMessageNotification, useMe, useIntl } from 'platform-components';
import { GRAVITIES, NOTIFICATION_THEMES } from 'platform-components/constants';
import { getFeatureFlags } from 'platform-components/src/components/app-factory/selectors';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMount } from 'react-use';
import ym from 'react-yandex-metrika';

import { COMMON_NOTIFICATION_DELAY } from 'common.components/constants';
import { MetrikaParams } from 'common.components/hooks/use-prep-lesson-click';
import { actions } from 'store/referral-code/actions';
import { getReferralCode, getReferralCodeLoadingStatus } from 'store/referral-code/selectors';

import { AfishaBanner } from './afisha-banner';

interface Props {
    className?: string;
    metrikaParams?: MetrikaParams;
}

export const AfishaBannerContainer = ({ className, metrikaParams }: Props) => {
    const featureFlags = useSelector(getFeatureFlags);
    const referralCode = useSelector(getReferralCode);
    const loadingStatus = useSelector(getReferralCodeLoadingStatus);
    const dispatch = useDispatch();
    const intl = useIntl();
    const teacherId = useMe()?.id;

    const bannerEnabled = featureFlags?.referralProgramBanner;

    useMount(() => {
        if (loadingStatus !== LOADING_STATUSES.SUCCESS && bannerEnabled) {
            dispatch(actions.loadReferralCode());
        }
    });

    if (!bannerEnabled || loadingStatus !== LOADING_STATUSES.SUCCESS) {
        return null;
    }

    const inputValue = intl.formatMessage({ id: 'afishaBanner.fullLink' }, { referalCode: referralCode });
    const sendBannerMetrika = () => {
        ym('reachGoal', 'teacher_referal_code_copy', {
            teacher_id: teacherId,
            from: metrikaParams?.from,
            link: inputValue,
        });
    };
    const showLinkCopiedToast = () =>
        dispatch(
            showIntlMessageNotification({
                closeDelay: COMMON_NOTIFICATION_DELAY,
                gravity: GRAVITIES.BOTTOM,
                messageId: 'toast.refLinkCopied',
                theme: NOTIFICATION_THEMES.TOAST,
            })
        );

    return (
        <AfishaBanner
            className={className}
            onClick={sendBannerMetrika}
            onCopyButtonClick={showLinkCopiedToast}
            text={inputValue}
        />
    );
};
